import { mixed, object } from "yup";

import { LossType } from "@api/operations.generated";
import { nonEmptyString, unit } from "@covertree/utils";

export interface LossDetailsForm {
  lossAddress: string;
  lotUnit: string;
  lossType: LossType;
}

export const validation = object({
  lossAddress: nonEmptyString("Loss address"),
  lotUnit: unit(),
  lossType: mixed<LossType>()
    .oneOf(Object.values(LossType), "Loss type is required")
    .required(),
});
